import { getElementById, moveAllChildren } from "../util/Utils";
import { filter, filterFooter } from "./Selectors";
import { fireFilterSubmit } from "../filter/FilterFormActions";
import { FilterAccordion } from "../filter/FilterAccordion";
import { setActiveConfiguration } from "@otto-ec/heureka-components/filter";
import { sheetV1 } from "@otto-ec/otto-components/sheet";
import { SvelteFacet } from "../filter/SvelteFacet";

const FILTER_DETAIL_SHEET_ID = "heureka-filterdetailsheet";
const FILTER_DETAIL_SHEET_CONTENT_CLASS = "heureka_filterDetailSheet__content";
const FILTER_DETAIL_SHEET_ACTIONS_CLASS = "heureka_filterDetailSheet__actions";
const FILTER_DETAIL_SHEET_CONTENT_SELECTOR = `.${FILTER_DETAIL_SHEET_CONTENT_CLASS}`;
const FILTER_DETAIL_SHEET_ACTIONS_SELECTOR = `.${FILTER_DETAIL_SHEET_ACTIONS_CLASS}`;

export default class OcFilterDetailSheet {
  /*               */

  constructor(
    private readonly filterId: string,
    private readonly sheet: sheetV1 | undefined = getElementById(FILTER_DETAIL_SHEET_ID),
    private readonly accordion: FilterAccordion | undefined = FilterAccordion.filterId(filterId),
    private readonly sheetContent: HTMLElement | null | undefined = sheet?.querySelector(
      FILTER_DETAIL_SHEET_CONTENT_SELECTOR,
    ),
    private readonly sheetActions: HTMLElement | null | undefined = sheet?.querySelector(
      FILTER_DETAIL_SHEET_ACTIONS_SELECTOR,
    ),
  ) {
    if (this.sheet) {
      this.sheet.headline = accordion?.filter?.filterTitle?.filterTitle;
    }
  }

  public static createForFilter(filterId: string) {
    return new OcFilterDetailSheet(filterId);
  }

  /*       */

  setSheet() {
    const form = filter(this.filterId);
    if (form) {
      if (this.sheetContent) {
        this.sheetContent.appendChild(form);
      }
      if (this.sheetActions) {
        moveAllChildren(filterFooter(form), this.sheetActions, true);
      }
    }
    return this;
  }

  initializeSheet() {
    if (this.sheet) {
      this.sheet.open = true;
      setActiveConfiguration("sheetSecondLevel", this.filterId);
      this.sheet?.addEventListener("oc-sheet-before-close", this.onClose);
    }
    return this;
  }

  /*                       */

  public deactivate() {
    this.sheet?.removeEventListener("oc-sheet-before-close", this.onClose);
    const source = this.sheetContent;
    if (source) {
      const detailSheetFacet = SvelteFacet.factory.pick(undefined, source);
      detailSheetFacet?.updateFeatureStatus("visible", "loaded");
    }

    const { accordion } = this;
    if (accordion) {
      accordion.filterForm = filter(this.filterId);
      accordion.filterFooter = this.sheetActions;
      accordion.filterFoldoutStatus = false;
    }

    return this;
  }

  public back() {
    this.sheet?.back();
    return this;
  }

  /*       */

  private onClose = () => {
    this.deactivate();
    const form = filter(this.filterId);
    if (form) {
      fireFilterSubmit(form);
    }
  };
}
